import { useState } from "react"
import { Link } from "react-router-dom"

export default function Footer() {

  const [email,setEmail] = useState("")
  const [status,setStatus] = useState("idle")
  const [clickCount, setClickCount] = useState(0)

  const handleSecretClick = () => {

  const newCount = clickCount + 1
  setClickCount(newCount)

  // reset dopo 2 secondi
  setTimeout(() => {
    setClickCount(0)
  }, 2000)

  if (newCount >= 5) {
    window.location.href = "/alkimya-admin-937"
  }
}
  const subscribe = async (e:any) => {

    e.preventDefault()
    setStatus("loading")

    try{

      const res = await fetch("https://api.brevo.com/v3/contacts",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "api-key": import.meta.env.VITE_BREVO_API_KEY
        },
        body:JSON.stringify({
          email: email,
          listIds:[5],
          updateEnabled:true
        })
      })

      if(res.ok){
        setStatus("success")
        setEmail("")
      }else{
        setStatus("error")
      }

    }catch{
      setStatus("error")
    }

  }

  return (

    <footer className="bg-neutral-100 border-t border-neutral-200">

      {/* NEWSLETTER */}

      <div className="max-w-7xl mx-auto px-6 py-14">

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">

          <div>

            <h3 className="text-xl font-semibold text-neutral-900">
              Ricevi aggiornamenti sulle ultime offerte
            </h3>

            <p className="text-neutral-600 mt-2">
              Promozioni esclusive, novità sui trattamenti e consigli skincare.
            </p>

          </div>

          <form onSubmit={subscribe} className="flex gap-3 w-full md:w-auto">

            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              required
              className="px-4 py-3 rounded-lg border border-neutral-300 bg-white focus:outline-none focus:border-black w-full md:w-72"
            />

            <button
              type="submit"
              className="px-6 py-3 bg-black text-white rounded-lg hover:bg-neutral-800 transition"
            >
              {status === "loading" ? "..." : "Iscriviti"}
            </button>

          </form>

        </div>

        {status === "success" && (
          <p className="text-green-600 mt-4">
            ✓ Controlla la tua email per il codice sconto
          </p>
        )}

        {status === "error" && (
          <p className="text-red-500 mt-4">
            Errore nell'iscrizione. Riprova.
          </p>
        )}

      </div>


      {/* FOOTER GRID */}

      <div className="max-w-7xl mx-auto px-6 pb-16">

        <div className="grid md:grid-cols-5 gap-12">

          {/* CONTATTI */}

          <div>

            <h4 className="font-semibold mb-4">
              Alkimya Estetica
            </h4>

            <p className="text-sm text-neutral-600 leading-relaxed">
              Via Colle Fiorito, 2<br/>
              00045 Genzano di Roma<br/>
              RM, Italia
            </p>

            <p className="mt-4 font-medium">
              06 8379 6865
            </p>

          </div>


          {/* ORARI */}

          <div>

            <h4 className="font-semibold mb-4">
              Orari
            </h4>

            <div className="text-sm text-neutral-600 space-y-2">

              <div className="flex justify-between">
                <span>Lunedì</span>
                <span>10:00 – 19:00</span>
              </div>

              <div className="flex justify-between">
                <span>Martedì – Venerdì</span>
                <span>09:00 – 19:00</span>
              </div>

              <div className="flex justify-between">
                <span>Sabato</span>
                <span>09:00 – 18:00</span>
              </div>

              <div className="flex justify-between">
                <span>Domenica</span>
                <span>Chiuso</span>
              </div>

            </div>

          </div>


          {/* SERVIZI */}

          <div>

            <h4 className="font-semibold mb-4">
              Servizi
            </h4>

            <nav className="flex flex-col gap-3 text-neutral-600 text-sm">

              <Link to="/trattamenti/viso" className="hover:text-black transition">
                Trattamenti viso
              </Link>

              <Link to="/trattamenti/corpo" className="hover:text-black transition">
                Trattamenti corpo
              </Link>

              <Link to="/trattamenti/laser" className="hover:text-black transition">
                Epilazione laser
              </Link>

              <Link to="/consulenza" className="hover:text-black transition">
                Consulenza personalizzata
              </Link>

            </nav>

          </div>


          {/* INFORMAZIONI */}

          <div>

            <h4 className="font-semibold mb-4">
              Informazioni
            </h4>

            <nav className="flex flex-col gap-3 text-neutral-600 text-sm">

              <Link to="/chi-siamo" className="hover:text-black transition">
                Il centro
              </Link>

              <Link to="/trattamenti" className="hover:text-black transition">
                Trattamenti
              </Link>

              <Link to="/gallery" className="hover:text-black transition">
                Gallery
              </Link>

              <Link to="/consulenza" className="hover:text-black transition">
                Consulenza
              </Link>

            </nav>

          </div>


          {/* TRUSTPILOT */}

          <div>

            <h4 className="font-semibold mb-4">
              Trustpilot
            </h4>

            <nav className="flex flex-col gap-3 text-neutral-600 text-sm">

              <a
                href="https://www.trustpilot.com/review/alkimyaestetica.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-black transition"
              >
                Lascia una recensione
              </a>

              <a
                href="https://www.trustpilot.com/review/alkimyaestetica.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-black transition"
              >
                Condividi la tua esperienza
              </a>

            </nav>

          </div>

        </div>

      </div>


      {/* SOCIAL */}

      <div className="border-t border-neutral-200">

        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row md:justify-between gap-4 text-sm text-neutral-500">

         <p
  onClick={handleSecretClick}
  className="cursor-default select-none"
>
  © 2026 Alkimya Estetica Avanzata
</p>

          <div className="flex gap-6">

            <Link to="/">
              Privacy Policy
            </Link>

            <Link to="/">
              Cookie Policy
            </Link>

          </div>

          <div className="flex gap-4">

            <a
              href="https://www.instagram.com/alkimyaestetica_avanzata/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>

            <a
              href="https://www.facebook.com/alkimyaestetica"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>


          </div>

        </div>

      </div>

    </footer>

  )
}